import { memo, useRef } from "react"
import { Seat } from "./Seat"

// Stable ref-assigning factory — one per index slot, never recreated
function useSeatRefCallbacks(seatRefs, count) {
    const cbRef = useRef([])
    while (cbRef.current.length < count) {
        const i = cbRef.current.length
        cbRef.current.push((el) => {
            if (el) seatRefs.current[i] = el
        })
    }
    return cbRef.current
}

export const SeatsLayer = memo(({
    seats,
    seatRefs,
    isMyTurn,
    getSeatPosition,
    getCardPosition,
    clearActionButtons,
    sendPlayerAction,
    dispatch,
    isCardsDealing,
    getCenterCardPos,
    // When true, non-local seats are rendered mirrored (scaleX -1) so the
    // table looks symmetric from the local player's perspective.
    // Configurable via SET_SYMMETRIC_OPPONENTS action. Defaults to true.
    symmetricOpponents = true,
    remaining,
    duration,
    seatNumber: timerSeatNumber
}) => {
    const refCallbacks = useSeatRefCallbacks(seatRefs, seats.length)

    return (
        <div className="truco-seat-container">
            {seats.map((seat, index) => {
                const { x, y, pointsX, pointsY } = getSeatPosition(index)
                return (
                    <Seat
                        key={seat?.id ?? index}
                        ref={refCallbacks[index]}
                        sendPlayerAction={sendPlayerAction}
                        name={seat?.name ?? ""}
                        cards={seat?.cards ?? []}
                        isMe={seat?.isMe ?? false}
                        seatClass=""
                        x={x}
                        y={y}
                        pointsX={pointsX}
                        pointsY={pointsY}
                        getCardPosition={getCardPosition}
                        getCenterCardPos={getCenterCardPos}
                        totalSeats={seats.length}
                        seatIndex={index}
                        seatNumber={seat?.serverSeatNumber ?? 0}
                        remaining={remaining}
                        duration={duration}
                        isMyTurn={isMyTurn}
                        showTimer={timerSeatNumber === index}
                        isCardsDealing={isCardsDealing}
                        clearActionButtons={clearActionButtons}
                        dispatch={dispatch}
                        points={seat?.points ?? 0}
                        trickWins={seat?.trickWins ?? [null, null, null]}
                        symmetricOpponents={symmetricOpponents}
                    />
                )
            })}
        </div>
    )
})